import React, { useEffect, useRef } from "react";

function Modal({ openModal, closeModal, children }) {
  const ref = useRef();

  useEffect(() => {
    if (openModal) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [openModal]);

  return (
    <dialog
      ref={ref}
      onCancel={closeModal}
      className="custom-dialog fade-in-top"
    >
      <div className="close" aria-label="Close" onClick={closeModal}></div>
      {children}
    </dialog>
  );
}

export default Modal;